import { render, staticRenderFns } from "./draggable.vue?vue&type=template&id=3a2fd880"
import script from "./draggable.vue?vue&type=script&lang=ts"
export * from "./draggable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports